import { useUserApiMutation } from "src/lib/filmwebid/useUserApiMutation";
import { useCallback, useState } from "react";

type UseRatingProps = {
	edi?: string | null;
	streamingId?: number | null;
	onComplete?: () => void;
	initialValue?: number;
}

export default function useRating({ edi = null, streamingId = null, initialValue, onComplete }: UseRatingProps):
	[doRating: (ratingValue: number | undefined) => void, isWorking: boolean, rating: number | undefined, isDone: boolean] {

	const [rating, setRating] = useState(initialValue);

	const { mutate, isPending, isSuccess } = useUserApiMutation("/api/Ratings", { allowAnon: false }, {
		onSuccess: onComplete,
	});

	const doRating = useCallback((ratingValue: number | undefined) => {
		if ((ratingValue ?? -1) >= 0) {
			setRating(ratingValue);
			mutate({
				method: "POST",
				body: {
					EDI: edi,
					streamingId,
					source: window?.location?.hostname,
					rating: ratingValue
				}
			});
		} else {
			setRating(undefined);
			mutate({
				method: "DELETE",
				params: { edi, streamingId }
			});
		}
	}, [edi, streamingId, mutate]);

	return [doRating, isPending, rating, isSuccess];
}